import { Info } from './interfaces';

export const MESSAGES: Info = {
  Hello: {
    accentColor: '#30c5ff',
    accentText: 'News Portal',
    description: 'Please choose the news media source that you prefer to read.',
    normalText: 'Welcome to',
  },
  ManyRequest: {
    accentColor: 'red',
    accentText: 'Sorry.',
    description: `You have made too many requests recently. Please reload page or try again later. Developer accounts are limited to 100 requests over a 24 hour period (50 requests available every 12 hours). Please upgrade to a paid plan if you need more requests.`,
    normalText: 'Oops... The «News Potral» probably unavailable.',
  },
  NoSources: {
    accentColor: 'red',
    accentText: 'is Empty',
    description: 'The «News API» probably unavailable. Please reload page or try again later.',
    normalText: 'Oops... The news media sources list',
  },
  NoNews: {
    accentColor: 'orange',
    accentText: 'Nothing',
    description: 'This news media source probably unavailable. Please choose another news media source or try again later.',
    normalText: 'Oops... There is',
  },
  ShowNews: {
    accentColor: '',
    accentText: '',
    description: '',
    normalText: '',
  },
};
